import * as React from "react";
import { useData, useDataValue, useErrors } from "../hooks/useData";
import { FormControlProps } from "./types";
import { toBool } from "../utils/conversion";
import { Icon } from "../ui/icons";
import { ErrorsDisplay } from "./Errors";
import { Label } from "./Label";

export function Checkbox(props: FormControlProps & {

    onChange?: (e: any, value: boolean) => void;
    onChangeValue?: (newValue: boolean) => boolean;
}) {

	const data = useData();
	let value = toBool(useDataValue(data, props.prop));
	const errors = useErrors(data, props.prop, props.errorsDisabled);

	// if (props.prop === "shareholder") {
	// 	debugger;
	// }


    function handleClick(e: any) {
        if (disabled) return;

		const {
            prop,
            onChangeValue,
        } = props;
        var newValue = !value;
        if (onChangeValue) {
            const result = onChangeValue(newValue);
            if (result !== undefined) {
                newValue = result;
            }
        }

        if (data && prop) {
			data.setValue(prop, newValue);
        }

		if (props.onChange) {
            props.onChange(e, newValue);
        }
    }


    const {
        className,
        disabled,
    } = props;

    var tick = null;
    if (value) {
        tick = <Icon type="tick" size="small" />
    }

    function handleKeyDown(e: any) {
        if (disabled) return;

		if (e.code === "Space" || e.code === "Enter") {
            handleClick(e);
        }
    }

    const input = (
        <div
            className={[className, "form-control checkbox", disabled ? "disabled" : ""].join(" ")}
            //onClick={handleClick}
            tabIndex={0}
            data-index={props["data-index"]}
			data-key={props["data-key"]}
            onKeyDown={handleKeyDown}
        >
            {tick}
        </div>
    );

	let label;
	if (props.title) {
		label = 
			<Label 
				title={props.title}
				isRequired={(props.def && props.def.options) ? props.def.options.required : false}
			/>;
	}
	return (
		<div
			className="flex group align-start"
			onClick={handleClick}
		>
			{label}
			<div className="">
				{input}
				<ErrorsDisplay errors={errors} onlyDisplayItems={!props.displayAllErrors} />
			</div>
		</div>
	);


}

